export default function itAssetDirective() {
  return {
    template: require('./ITAsset.html'),
    scope: {
      customerId: '<',
      department: '=',
      process: '=',
      function: '=',
      itAsset: '=',
      isEdit: '<',
      tooltipAppendToSelector: '@',
    },
    controller: 'ITAssetController',
    controllerAs: 'itAssetVM',
    bindToController: true,
    replace: true,
  };
}
